import type { ReactElement } from 'react';

import { PersonPicker } from '@/features/people/components/PersonPicker';
import type { PersonSelection } from '@/features/people/types';

interface Props {
  selection: PersonSelection | null;
  onSelect: (s: PersonSelection | null) => void;
  firstName: string;
  lastName: string;
  onFirstName: (v: string) => void;
  onLastName: (v: string) => void;
}

const ORIGIN: Record<PersonSelection['kind'], string> = {
  qms: 'En el QMS',
  lms: 'Del LMS: se agregará al QMS al otorgar',
  invite: 'Proveedor externo: recibirá un correo para crear su contraseña',
};

/** Persona a la que se otorga el acceso: buscador único, o la persona elegida con su
 *  origen y "Cambiar". Si es una invitación, pide nombre y apellidos. */
export function PersonField(p: Props): ReactElement {
  if (p.selection === null) {
    return <PersonPicker allowInvite onSelect={p.onSelect} />;
  }
  const label = p.selection.kind === 'invite' ? p.selection.email : p.selection.name;
  return (
    <>
      <div className="fld">
        <span className="fld-lab">Persona</span>
        <div className="person-chosen">
          <strong>{label}</strong>
          <span className="soft">{ORIGIN[p.selection.kind]}</span>
          <button type="button" className="btn mut sm" onClick={() => p.onSelect(null)}>
            Cambiar
          </button>
        </div>
      </div>
      {p.selection.kind === 'invite' && (
        <>
          <label className="fld">
            <span className="fld-lab">Nombre</span>
            <input
              type="text"
              className="selector fw"
              value={p.firstName}
              maxLength={100}
              autoComplete="off"
              onChange={(e) => p.onFirstName(e.target.value)}
            />
          </label>
          <label className="fld">
            <span className="fld-lab">Apellidos</span>
            <input
              type="text"
              className="selector fw"
              value={p.lastName}
              maxLength={100}
              autoComplete="off"
              onChange={(e) => p.onLastName(e.target.value)}
            />
          </label>
        </>
      )}
    </>
  );
}
